import {
  Globe,
  Smartphone,
  Code2,
  PenTool,
  Cloud,
  ShieldCheck,
  Compass,
  Headphones,
} from "lucide-react";

export const IMAGES = {
  code: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzb2Z0d2FyZSUyMGVuZ2luZWVyaW5nJTIwdGVjaCUyMG9mZmljZSUyMGxhcHRvcCUyMGRldmVsb3BlcnxlbnwwfHx8fDE3ODg1MzEyNjh8MA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1629904853893-c2c8981a1dc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzb2Z0d2FyZSUyMGVuZ2luZWVyaW5nJTIwdGVjaCUyMG9mZmljZSUyMGxhcHRvcCUyMGRldmVsb3BlcnxlbnwwfHx8fDE3ODg1MzEyNjh8MA&ixlib=rb-4.1.0&q=85",
  cloud: "https://images.unsplash.com/photo-1667372283496-893f0b1e7c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxjbG91ZCUyMGN5YmVyc2VjdXJpdHklMjBzZXJ2ZXIlMjB0ZWNobm9sb2d5JTIwYWJzdHJhY3R8ZW58MHx8fHwxNzg4NTMxMjY4fDA&ixlib=rb-4.1.0&q=85",
  security: "https://images.unsplash.com/photo-1667372283587-e1557c08aca4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjbG91ZCUyMGN5YmVyc2VjdXJpdHklMjBzZXJ2ZXIlMjB0ZWNobm9sb2d5JTIwYWJzdHJhY3R8ZW58MHx8fHwxNzg4NTMxMjY4fDA&ixlib=rb-4.1.0&q=85",
  mobile: "https://images.unsplash.com/photo-1784407090680-335328788832?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxzbWFydHBob25lJTIwbW9ja3VwJTIwbW9iaWxlJTIwYXBwJTIwdXglMjBkZXNpZ258ZW58MHx8fHwxNzg4NTMxMjY4fDA&ixlib=rb-4.1.0&q=85",
  uiux: "https://images.unsplash.com/photo-1784407097298-759eb54e8aeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxzbWFydHBob25lJTIwbW9ja3VwJTIwbW9iaWxlJTIwYXBwJTIwdXglMjBkZXNpZ258ZW58MHx8fHwxNzg4NTMxMjY4fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "web-development",
    icon: Globe,
    name: "Website Development",
    tagline: "High-performance websites, portals and web applications.",
    desc: "Conversion-focused marketing sites, headless commerce, customer portals and complex web platforms — engineered for speed, SEO and scale.",
    deliverables: ["Custom web applications", "E-commerce & headless CMS", "Progressive web apps", "Performance & SEO optimisation"],
    stack: ["React", "Next.js", "Node.js", "FastAPI", "AWS"],
    image: IMAGES.code,
    href: "/services/web-development",
  },
  {
    slug: "mobile-apps",
    icon: Smartphone,
    name: "Mobile App Development",
    tagline: "Native and cross-platform apps users love.",
    desc: "iOS, Android and cross-platform apps built with React Native and Flutter — from MVP to enterprise rollouts with app-store delivery handled end to end.",
    deliverables: ["iOS & Android native apps", "React Native / Flutter builds", "App store launch & ASO", "Ongoing app maintenance"],
    stack: ["React Native", "Flutter", "Swift", "Kotlin"],
    image: IMAGES.mobile,
    href: "/services/app-software",
  },
  {
    slug: "custom-software",
    icon: Code2,
    name: "Custom Software",
    tagline: "Bespoke platforms and SaaS engines.",
    desc: "Tailored business software, SaaS products, API ecosystems and legacy modernisation that streamline operations and unlock new revenue.",
    deliverables: ["SaaS product engineering", "Internal tools & dashboards", "API & microservices", "Legacy system modernisation"],
    stack: ["Python", "FastAPI", "PostgreSQL", "GraphQL", "Docker"],
    image: IMAGES.team,
    href: "/services/app-software",
  },
  {
    slug: "ui-ux",
    icon: PenTool,
    name: "UI/UX Design",
    tagline: "Interfaces engineered around your users.",
    desc: "Research-led product design, design systems and prototypes that turn complex workflows into simple, elegant experiences.",
    deliverables: ["UX research & audits", "Product design & prototyping", "Design systems", "Usability testing"],
    stack: ["Figma", "Design systems", "Prototyping"],
    image: IMAGES.uiux,
    href: "/services",
  },
  {
    slug: "cloud",
    icon: Cloud,
    name: "Cloud Solutions",
    tagline: "Migrate, modernise and scale with confidence.",
    desc: "AWS, Azure and GCP architecture, migration and cost optimisation with DevOps pipelines that ship reliably, day after day.",
    deliverables: ["Cloud migration & architecture", "DevOps & CI/CD pipelines", "Cost optimisation", "Kubernetes & containers"],
    stack: ["AWS", "Azure", "GCP", "Kubernetes", "Terraform"],
    image: IMAGES.cloud,
    href: "/services/it-cloud-security",
  },
  {
    slug: "cybersecurity",
    icon: ShieldCheck,
    name: "Cybersecurity",
    tagline: "Zero-trust protection for your business.",
    desc: "Security audits, penetration testing, zero-trust architecture and compliance support that keep your data and reputation safe.",
    deliverables: ["Security audits & pen-testing", "Zero-trust architecture", "GDPR & ISO 27001 readiness", "Incident response planning"],
    stack: ["Zero Trust", "SIEM", "IAM", "Encryption"],
    image: IMAGES.security,
    href: "/services/it-cloud-security",
  },
  {
    slug: "consulting",
    icon: Compass,
    name: "IT Consulting",
    tagline: "Technology strategy that pays for itself.",
    desc: "Pragmatic technology roadmaps, vendor selection and digital transformation guidance from experienced professionals — not salespeople.",
    deliverables: ["Technology roadmaps", "Digital transformation", "Vendor & stack selection", "Team augmentation"],
    stack: ["Strategy", "Architecture", "Due diligence"],
    image: IMAGES.team,
    href: "/services",
  },
  {
    slug: "support",
    icon: Headphones,
    name: "IT Support & Maintenance",
    tagline: "24/7 managed support with real SLAs.",
    desc: "Proactive monitoring, network solutions, helpdesk support and maintenance plans that keep your business running around the clock.",
    deliverables: ["24/7 monitoring & helpdesk", "Network design & solutions", "Backup & disaster recovery", "SLA-backed maintenance plans"],
    stack: ["24/7 NOC", "Networking", "DR & Backup"],
    image: IMAGES.cloud,
    href: "/services/it-cloud-security",
  },
];

export const STACK = [
  "React", "TypeScript", "Next.js", "Python", "FastAPI", "Node.js", "AWS", "Azure",
  "Docker", "Kubernetes", "Terraform", "GraphQL", "PostgreSQL", "iOS", "Android", "React Native",
];

export const STATS = [
  { value: 120, suffix: "+", label: "Projects delivered" },
  { value: 99.99, suffix: "%", label: "Uptime across managed systems", decimals: 2 },
  { value: 40, suffix: "+", label: "UK & global clients" },
  { value: 24, suffix: "/7", label: "Support & monitoring" },
];

export const CASE_STUDIES = [
  {
    client: "The Copper Kettle Café",
    sector: "Hospitality · York",
    title: "New website with online table booking",
    result: "Fully booked most weekends since launch",
    image: IMAGES.code,
  },
  {
    client: "Blossom & Bloom Florists",
    sector: "Retail · Bath",
    title: "Simple online shop for local deliveries",
    result: "Steady online orders from local customers",
    image: IMAGES.mobile,
  },
  {
    client: "Turner & Sons Plumbing",
    sector: "Trades · Leeds",
    title: "Website refresh and Google visibility",
    result: "More phone enquiries coming in every week",
    image: IMAGES.security,
  },
];

export const TESTIMONIALS = [
  {
    quote: "TechAxis built our new website and online booking in just a few weeks. Customers now find us on Google and ring us straight from the site.",
    name: "Mark Turner",
    role: "Owner, Turner & Sons Plumbing, Leeds",
  },
  {
    quote: "They listened, explained everything in plain English and never pushed extras we didn't need. Our little shop finally takes online orders.",
    name: "Priya Shah",
    role: "Owner, Blossom & Bloom Florists, Bath",
  },
  {
    quote: "When our till software kept crashing, TechAxis moved us to something reliable and now looks after our IT. One less thing to worry about.",
    name: "Dave Whitfield",
    role: "Manager, The Copper Kettle Café, York",
  },
];

export const MANIFESTO = [
  { n: "01", title: "Precision engineering", body: "We write software the way engineers build bridges — measured, tested and built to carry real weight for years." },
  { n: "02", title: "Security by design", body: "Security is not a feature we bolt on. It is woven into every architecture decision from day one." },
  { n: "03", title: "Radical clarity", body: "No jargon, no black boxes. You always know what we are building, why, and what it costs." },
  { n: "04", title: "Partnership over projects", body: "We measure success by your outcomes — growth, efficiency and reliability — long after launch day." },
];
